import {
  TestCaseLevel1Policy,
  TestCaseLevel2Policy,
  TestCaseLevel3Policy,
} from "@design-controls/types";
import i18n from "../i18n/config";

type TestCaseConfiguration = {
  testCase1?: TestCaseLevel1Policy;
  testCase2?: TestCaseLevel2Policy;
  testCase3?: TestCaseLevel3Policy;
};

export const INITIAL_TESTCASE_CONFIGURATION: TestCaseConfiguration = {
  testCase1: {
    codePrefix: i18n.t("testCases.initialConfiguration.testCase1.codePrefix"),
    label: i18n.t("testCases.initialConfiguration.testCase1.label"),
    codeStrategy: "GENERATED",
    type: "testCase1",
  },
  testCase2: {
    codePrefix: i18n.t("testCases.initialConfiguration.testCase2.codePrefix"),
    label: i18n.t("testCases.initialConfiguration.testCase2.label"),
    codeStrategy: "GENERATED",
    type: "testCase2",
  },
} as const;
